var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2904 4.90723H7.6237C6.15703 4.90723 4.95703 6.10723 4.95703 7.57389V26.2406C4.95703 27.7072 6.15703 28.9072 7.6237 28.9072H26.2904C27.757 28.9072 28.957 27.7072 28.957 26.2406V7.57389C28.957 6.10723 27.757 4.90723 26.2904 4.90723ZM26.2904 26.2406H7.6237V7.57389H26.2904V26.2406Z",
    fill: "#304050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.29 16.9071H12.9567V23.5738H10.29V16.9071ZM20.9567 10.2405H23.6234V23.5738H20.9567V10.2405ZM15.6234 19.5738H18.29V23.5738H15.6234V19.5738ZM15.6234 14.2405H18.29V16.9071H15.6234V14.2405Z",
    fill: "#304050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.2f76cbd046316c1ea72c3eaec1f6f266.svg";
export { ForwardRef as ReactComponent };